export default __webpack_public_path__ + "static/media/Fullstack.8fd53fb8.svg";